// @ts-nocheck
import _ from 'lodash';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line you-dont-need-lodash-underscore/last, you-dont-need-lodash-underscore/split
const suffix = (path) => _.last(_.split(path, '.'));

export { suffix };
